import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { AttachFile } from '@mui/icons-material';
import { PostFile } from '../types/forum.types';

interface FileDisplayProps {
  files: PostFile[];
  postId: string;
  loadedImages: { [key: string]: string };
}

export const FileDisplay: React.FC<FileDisplayProps> = ({ files, postId, loadedImages }) => {
  if (!files || files.length === 0) return null;

  return (
    <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column' }}>
      {files.map((file) => {
        const isImage = file.filename.match(/\.(jpg|jpeg|png|gif)$/i);
        const fileKey = `${postId}_${file.filename}`;
        const loadedImage = loadedImages[fileKey];

        return isImage ? (
          <Box key={file.id} sx={{ mt: 1 }}>
            {loadedImage ? (
              <img
                src={loadedImage}
                alt={file.filename}
                style={{
                  width: '100%',
                  maxHeight: '600px',
                  objectFit: 'contain',
                  borderRadius: '8px',
                  backgroundColor: 'rgba(0, 0, 0, 0.03)',
                  padding: '8px'
                }}
              />
            ) : (
              <Typography variant="body2" color="text.secondary">
                Loading image...
              </Typography>
            )}
          </Box>
        ) : (
          <Link
            key={file.id}
            href={`${import.meta.env.VITE_API_URL}/forum/uploads/${postId}/${file.filename}`}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              color: 'primary.main',
              textDecoration: 'none',
              '&:hover': { textDecoration: 'underline' }
            }}
          >
            <AttachFile sx={{ fontSize: 20 }} />
            {file.filename}
          </Link>
        );
      })}
    </Box>
  );
}; 